import fetch from 'isomorphic-fetch';

import {
  endSlackFetch,
  startSlackFetch,
  updateSlackTeamInfo,
} from 'actions/slack';
import { SLACK } from 'constants/shares';
import * as sentry from 'utilities/sentry';

import { hasSlackAppScopes } from '../../../shared/utilities/slack';

export function getSlackInfoCreator() {
  return (dispatch, getState) => {
    const {
      is_logged_in: isLoggedIn,
      current: { oauth },
    } = getState().user;

    if (
      !isLoggedIn ||
      !oauth[SLACK] ||
      !hasSlackAppScopes(oauth[SLACK].scopes)
    ) {
      dispatch(endSlackFetch());

      return;
    }

    dispatch(startSlackFetch());

    return fetch('/v1/users/slack', {
      method: 'GET',
      credentials: 'include',
    })
      .then(resp => {
        if (resp.status >= 400) {
          throw new Error(
            `Oops! Error fetching slack response: ${resp.status}`
          );
        }

        return resp.json();
      })
      .then(respJSON => {
        dispatch(updateSlackTeamInfo(respJSON));
        dispatch(endSlackFetch());

        return respJSON;
      })
      .catch(err => {
        dispatch(endSlackFetch());

        sentry.logException(
          err,
          'Exception while fetching slack info for user'
        );
      });
  };
}
